export default __webpack_public_path__ + "static/media/School Hall.630ac72b.jpg";